var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker-goods-sku"},[_c('div',{staticClass:"item-name"},[_c('div',[_vm._v("商品名称："+_vm._s(_vm.value.itemName))]),_c('div',[_vm._v("商品编码："+_vm._s(_vm.value.itemBn))])]),_c('SpFinder',{ref:"finder",attrs:{"setting":_vm.setting,"row-actions-align":'left',"hooks":{
      beforeSearch: _vm.beforeSearch,
      afterSearch: _vm.afterSearch
    },"url":"/goods/items"},on:{"selection-change":_vm.onSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }